import { useSadlSet as useSadlSetApi } from 'api/hooks/useSadlSet';
import { Set } from 'api/models/Sets';

const useSadlSet = ({ deliverySet, supplierTenantName }: { deliverySet?: Set; supplierTenantName?: string }) => {
  const { data: sadlSetByDisplayCode } = useSadlSetApi(
    {
      serial: (deliverySet?.isSadlSet && deliverySet?.displayCode) || '',
      supplier_tenant_name: supplierTenantName || '',
    },
    { ignoreGlobalError: true },
  );

  const { data: sadlSetBySerial } = useSadlSetApi(
    {
      serial: (!sadlSetByDisplayCode && deliverySet?.isSadlSet && deliverySet?.serial) || '',
      supplier_tenant_name: supplierTenantName || '',
    },
    { ignoreGlobalError: true },
  );

  return sadlSetByDisplayCode || sadlSetBySerial;
};

export default useSadlSet;
